import { render, staticRenderFns } from "./TaxesList.vue?vue&type=template&id=4028bc5b"
import script from "./TaxesList.vue?vue&type=script&lang=js"
export * from "./TaxesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports